import { DisbursementType } from "../shared/CaseConfiguration.ts";
import { CostTotals, getCostsTotal } from "../shared/CaseModelUtility.ts";
import { Costs } from "../shared/CostModel.ts";
import { vatOnCosts } from "../shared/vat.ts";

export interface CostSummaryValues {
  totalCosts: number;
  incurredCosts: number;
  estimatedCosts: number;
  disbursements: { [type in DisbursementType]: number };
  lawFirmFees: number;
  // what of the law firm fees and of each disbursement is incurred already
  incurredByType: {
    disbursements: { [type in DisbursementType]: number };
    lawFirmFees: number;
  };
  // the VAT the party pays on its costs: 0 when it reclaims it
  vat: number;
}

export function getCostSummary(
  {
    costs,
  }: {
    costs: Costs[];
  },
  vatRate?: number,
): CostSummaryValues {
  const totals = new CostTotals();
  costs.forEach((costs) => totals.add(getCostsTotal(costs)));

  const {
    total,
    disbursements: { courtFee, barristerFee, otherDisbursement, expertFee },
    lawFirmFees,
  } = totals.getAll();
  const incurred = totals.getIncurred();

  return {
    totalCosts: total.toNumber(),
    estimatedCosts: totals.getEstimatedTotal().toNumber(),
    incurredCosts: totals.getIncurredTotal().toNumber(),
    lawFirmFees: lawFirmFees.toNumber(),
    disbursements: {
      courtFee: courtFee.toNumber(),
      barristerFee: barristerFee.toNumber(),
      otherDisbursement: otherDisbursement.toNumber(),
      expertFee: expertFee.toNumber(),
    },
    incurredByType: {
      lawFirmFees: incurred.lawFirmFees.toNumber(),
      disbursements: {
        courtFee: incurred.disbursements.courtFee.toNumber(),
        barristerFee: incurred.disbursements.barristerFee.toNumber(),
        otherDisbursement: incurred.disbursements.otherDisbursement.toNumber(),
        expertFee: incurred.disbursements.expertFee.toNumber(),
      },
    },
    vat: vatOnCosts(totals.getAll(), vatRate).toNumber(),
  };
}
